/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React, { useMemo } from "react"
import { Helmet } from "react-helmet"
import { getCloudinaryOgImageUrl } from "../lib/utils"

interface Props {
  description: string
  meta: any[]
  title: string
  imageUrl?: string
}

export function SEO({ description, meta, title, imageUrl }: Props) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  )

  const ogImage = imageUrl
    ? { name: "og:image", content: getCloudinaryOgImageUrl(imageUrl) }
    : undefined

  const pageTitle = useMemo(() => {
    let t = `${title} | Schriktraining Deluxe`

    if (t.length < 65) {
      return t
    }

    t = `${title} | Schriktraining`
    if (t.length < 65) {
      return t
    }

    return title
  }, [title, site])

  return (
    <Helmet
      htmlAttributes={{
        lang: "nl",
      }}
      title={pageTitle}
      meta={[
        ...meta,
        ogImage,
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: description,
        },
      ].filter((n) => n)}
    />
  )
}

SEO.defaultProps = {
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}
